var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-input-delivery-method"},[_vm._m(0),_c('SelectionAccordion',{attrs:{"name":"deliveryMethod","value":_vm.deliveryMethod,"options":_vm.deliveryMethodOptions},on:{"input":_vm.setDeliveryMethodOption}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h4',[_vm._v("Delivery method")])])
}]

export { render, staticRenderFns }